var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTargetIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6127 12.0008C11.6127 12.2366 11.7064 12.4627 11.8731 12.6294C12.0398 12.7961 12.2659 12.8897 12.5016 12.8897C12.7374 12.8897 12.9635 12.7961 13.1302 12.6294C13.2969 12.4627 13.3905 12.2366 13.3905 12.0008C13.3905 11.7651 13.2969 11.539 13.1302 11.3723C12.9635 11.2056 12.7374 11.1119 12.5016 11.1119C12.2659 11.1119 12.0398 11.2056 11.8731 11.3723C11.7064 11.539 11.6127 11.7651 11.6127 12.0008Z",
    stroke: "#6929E2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5015 7.55524C11.6226 7.55524 10.7635 7.81585 10.0327 8.30412C9.30199 8.79239 8.73244 9.48638 8.39611 10.2983C8.05979 11.1103 7.97179 12.0038 8.14325 12.8657C8.3147 13.7277 8.73792 14.5195 9.35936 15.1409C9.98081 15.7624 10.7726 16.1856 11.6346 16.3571C12.4965 16.5285 13.39 16.4405 14.202 16.1042C15.0139 15.7679 15.7079 15.1983 16.1962 14.4676C16.6845 13.7368 16.9451 12.8777 16.9451 11.9988",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3902 4.0514C11.7426 3.86655 10.0782 4.19829 8.6274 5.0007C7.17655 5.80312 6.0109 7.03657 5.29171 8.53042C4.57252 10.0243 4.33532 11.7047 4.61292 13.3393C4.89053 14.9738 5.66922 16.4817 6.84128 17.6544C8.01335 18.827 9.52085 19.6065 11.1553 19.8849C12.7897 20.1633 14.4702 19.927 15.9644 19.2085C17.4587 18.4901 18.6927 17.3251 19.4958 15.8746C20.299 14.4242 20.6316 12.76 20.4476 11.1123",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1677 6.66872V9.33488H17.8339L20.5 6.66872H17.8339V4.00256L15.1677 6.66872Z",
    stroke: "#6929E2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1689 9.33551L12.5022 12.0022",
    stroke: "#6929E2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTargetIc);
export default __webpack_public_path__ + "static/media/target-ic.f8bd0da103a58ddd9cafa25d5e0b3873.svg";
export { ForwardRef as ReactComponent };